import { useEffect, useMemo, useState } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { useProductTemplateContext } from "@/components/product-template-context-provider";
import { useSiteSelectorContext } from "@/components/site-selector-modal/site-selector-context";

import JiraServiceManagementSoftwareNavV2 from "./software-jira-service-management-navbarv2";

const JiraServiceManagementSoftwareNavV2Uniform = () => {
    const { template } = useProductTemplateContext();
    const { openModalForTemplate } = useSiteSelectorContext();
    const [isUseOpenCrossFlow, setIsUseOpenCrossFlow] = useState(false);

    const openModalForTemplateClickAction = useMemo(() => {
        return (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            event.stopPropagation();
            openModalForTemplate({
                templateId: template?.templateId as string,
                templateName: template?.templateName as string,
                productKey: template?.productKey as ProductKeys
            });
        };
    }, [
        openModalForTemplate,
        template?.templateId,
        template?.templateName,
        template?.productKey
    ]);

    useEffect(() => {
        if (
            template?.templateId &&
            template?.templateName &&
            template?.productKey
        ) {
            setIsUseOpenCrossFlow(true);
        }
    }, [template?.templateId, template?.templateName, template?.productKey]);

    return (
        <JiraServiceManagementSoftwareNavV2
            productNavCtaCTAClickFunction={openModalForTemplateClickAction}
            isUseOpenCrossFlow={isUseOpenCrossFlow}
        />
    );
};

JiraServiceManagementSoftwareNavV2Uniform.displayName =
    "JiraServiceManagementSoftwareNavV2Uniform";

export default JiraServiceManagementSoftwareNavV2Uniform;
